exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.bankAccountList>.item-link>.item-content>.item-inner>.item-title-row>.item-title {\n  color: #12bcf1 !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d1d1afca","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/bankAccounts/CMBankAccountsPage/CMBankAccountsListStatement.vue
// module id = 1170
// module chunks = 2